



















import { defineComponent, reactive, toRefs, computed, ref, onMounted, PropType } from '@vue/composition-api';
import * as Common from "../commons/common"
import http from "../plugins/http";
import moment from 'moment';

export interface Data {
  sumup_group_id: string
  sumup_unit_id: string
}

export default defineComponent({
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sumup_group_id: null,
      sumup_unit_id: null,
    });

    const toSumupDetail = (sumup_unit: any | null) => {
      if(sumup_unit == null){
        context.root.$router.push(`/teacher_site/practice_sumup_detail_total/${state.sumup_group_id}`).catch(err => {});
      }else{
        context.root.$router.push(`/teacher_site/practice_sumup_detail_curriculum/${state.sumup_group_id}/${sumup_unit.id}`);
      window.location.reload();
      }
      location.reload();
    };

    /******************************
     * Excelダウンロード
     ******************************/

    const downloadExcel = async () => {

      alert("ダウンロードを開始します。受験者数が多い場合、時間がかかる場合があります。ウェブブラウザを閉じずにお待ちください。");

      await http.get(`/api/teacher/practice_sumup_detail_total/download_excel/${context.root.$route.params.sumup_group_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `detail_result_${moment().format('Y-M-D')}.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          alert(`エクセルのダウンロードに失敗しました。\n${errorData.errors[0]}`);
        }else{
          alert("エクセルのダウンロードに失敗しました。");
        }
      });
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.sumup_group_id = context.root.$route.params.sumup_group_id;
      state.sumup_unit_id = context.root.$route.params.sumup_unit_id;
    });

    return {
      ...toRefs(state),
      downloadExcel,
      toSumupDetail
    };
  }
})
